document.addEventListener("DOMContentLoaded", function () {
  const lang = document.documentElement.getAttribute("lang");
  const getLang = lang === "de" ? "" : `${lang}/`;
  fetch(`https://blog.runningcoach.me/${getLang}wp-json/wp/v2/posts?per_page=3&_embed`)
    .then((response) => response.json())
    .then((posts) => {
      const cards = document.querySelectorAll("#latest-posts .card");
      posts.forEach((post, index) => {
        const card = cards[index];
        if (card) {
          // Set Post Title
          const titleElement = card.querySelector(".post-title");
          titleElement.innerHTML = post.title.rendered;

          // Set Post Link
          const linkElement = card.querySelector(".post-link");
          linkElement.href = post.link;

          // Set Featured Image
          const imageElement = card.querySelector(".post-image");
          const media = post._embedded["wp:featuredmedia"];
          if (media && media[0] && media[0].source_url) {
            imageElement.src = media[0].source_url;
          }
        }
      });
    })
    .catch((error) => {
      console.error("Error fetching WordPress posts:", error);
    });
});
